export default function debounce(callback, wait) {
    let debounceTimer;

    function debounced(...args) {
        const delayedFunction = () => {
            debounceTimer = null;
            callback.apply(this, args);
        };

        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }

        debounceTimer = setTimeout(delayedFunction, wait ?? 300);
    }

    debounced.cancel = () => {
        clearTimeout(debounceTimer);
        debounceTimer = null;
    };

    return debounced;
}
